import { gql } from '@apollo/client';
import { ErrorMessageInfo } from '@retainerclub/shared-api';

export default gql`
  mutation actionEmailSuppressionTriage(
    $input: EmailSuppressionTriageActionInput!
  ) {
    actionEmailSuppressionTriage(input: $input) {
      clientMutationId
      errorMessages {
        ...ErrorMessageInfo
      }
      emailSuppression {
        id
        status
        triageStatus
        resolvedAt
        resolutionNote
      }
    }
  }
  ${ErrorMessageInfo}
`;
